import { Components } from '@mui/material';
import { Theme } from '@mui/material/styles';

export function getMuiMenu(theme: Theme): Components['MuiMenu'] {
  return {
    styleOverrides: {
      paper: {
        '&&': {
          padding: 0,
          borderRadius: 12,
          backgroundColor: theme.palette.grey[700],

          '&:before': {
            display: 'none',
          },
        },
      },
      list: {
        padding: 0,
      },
    },
  };
}
